// Exposes the formatting helpers as `$CAM` on window, which the HAML views and
// the coffee behaviours use as a global. Must be imported before the
// behaviours, ES module imports are evaluated before any statement in the
// importing module, so this cannot live in the pack entrypoints themselves.
import {
  parseCurrency,
  formatCurrency,
  formatPhoneNumber,
  formatIban,
  formatChUid,
  formatCreditCard,
  formatFileSize
} from 'shared/helpers/numbers'

import { translate } from 'shared/helpers/translations'

window.$CAM = window.$CAM || {}
window.$CAM.parseCurrency = parseCurrency
window.$CAM.formatCurrency = formatCurrency
window.$CAM.formatPhoneNumber = formatPhoneNumber
window.$CAM.formatIban = formatIban
window.$CAM.formatChUid = formatChUid
window.$CAM.formatCreditCard = formatCreditCard
window.$CAM.formatFileSize = formatFileSize
window.$CAM.translate = window.$CAM.t = translate
